import { render } from "./mobile-bottom-nav.vue?vue&type=template&id=7151c39c&scoped=true"
import script from "./mobile-bottom-nav.vue?vue&type=script&lang=js"
export * from "./mobile-bottom-nav.vue?vue&type=script&lang=js"

import "./mobile-bottom-nav.vue?vue&type=style&index=0&id=7151c39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7151c39c"]])

export default __exports__